// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3zfOD","header":"MergedInvoice_header___qqtx"};